import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
    Grid,
    Row,
    Col,
    Glyphicon,
    Button,
    ButtonToolbar,
    Panel,
    Image,
    Modal,
    FormGroup,
    ControlLabel,
    FormControl,
    OverlayTrigger,
    Popover,
} from 'react-bootstrap'
import * as actions from '../../actions/user'
import Alert from '../alert'
import HtmlTitle from '../html-title'
import Password from '../login/password'
import auth from '../../auth'
import Confirm from '../confirm'
import { OPERATIONS_ADMIN, OPERATIONS_COORDINATOR } from '../../utils/role'

class View extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showPasswordModal: false,
            currentPassword: '',
            newPassword: '',
            validNewPassword: false,
            showDeleteUserConfirm: false,
        }
    }

    canEdit = auth.hasAnyRole(OPERATIONS_ADMIN, OPERATIONS_COORDINATOR)

    renderDeleteUserConfirmation() {
        const { showDeleteUserConfirm } = this.state
        const { user } = this.props

        return (
            <Confirm
                show={showDeleteUserConfirm}
                title="Delete user"
                bsStyle="danger"
                onClose={this.closeDeleteUserConfirm}
                onConfirm={() => {
                    this.props.actions.deleteUser(user.id)
                    setTimeout(() => {
                        this.props.router.push('/admin/users')
                    }, 1000)
                }}
            >
                Are you sure you want to suspend this user? It cannot be reverted.
            </Confirm>
        )
    }

    componentDidMount() {
        this.props.actions.fetchCurrentUser()
        this.props.actions.fetchUser(this.props.params.id)
    }

    changePassword = () => {
        this.props.actions.changePassword(this.props.params.id, this.state.currentPassword, this.state.newPassword)
    }

    onCurrentPasswordChange = (e) => {
        this.setState({ currentPassword: e.target.value })
    }

    onNewPasswordChange = (result) => {
        this.setState({ newPassword: result.password, validNewPassword: result.valid })
    }

    openPasswordModal = () => {
        this.setState({ showPasswordModal: true })
    }

    closePasswordModal = () => {
        this.setState({ showPasswordModal: false })
    }

    openDeleteUserConfirm = () => {
        this.setState({ showDeleteUserConfirm: true })
    }

    closeDeleteUserConfirm = () => {
        this.setState({ showDeleteUserConfirm: false })
    }

    renderDeleteUser() {
        if (this.props.user.editable == null || !this.props.user.editable) {
            return null
        }

        if (this.props.user.managedByShiftbuddy === true) {
            const managedByShiftbuddyPopover = (
                <Popover id="managed-by-shiftbuddy-popover">
                    This account is managed by Shiftbuddy and cannot be suspended here.
                </Popover>
            )
            return (
                <OverlayTrigger placement="top" overlay={managedByShiftbuddyPopover}>
                    <span style={{ display: 'inline-block', marginLeft: '5px' }}>
                        <Button bsStyle="danger" disabled style={{ pointerEvents: 'none' }}>
                            <Glyphicon glyph="trash" /> Suspend Account
                        </Button>
                    </span>
                </OverlayTrigger>
            )
        }

        return (
            <Button bsStyle="danger" onClick={this.openDeleteUserConfirm}>
                <Glyphicon glyph="trash" /> Suspend Account
            </Button>
        )
    }

    renderEditPassword() {
        if (this.props.user.editable == null || !this.props.user.editable) {
            return null
        }

        return (
            <Button onClick={this.openPasswordModal}>
                <Glyphicon glyph="lock" /> Change Password
            </Button>
        )
    }

    renderEditUser() {
        if (this.props.user.editable == null || !this.props.user.editable) {
            return null
        }

        return (
            <Link className="btn btn-primary" to={`/admin/users/${this.props.user.id}/edit`}>
                <Glyphicon glyph="pencil" /> Edit User
            </Link>
        )
    }

    renderPasswordModal() {
        const { firstName, lastName, email, phoneNumber } = this.props.user

        let alert
        if (this.props.changePasswordStatus === 200) {
            alert = <Alert type="success" message="Password changed" />
        } else if (this.props.changePasswordStatus === 403) {
            alert = <Alert type="danger" message="Wrong password / permission denied" />
        }

        return (
            <Modal show={this.state.showPasswordModal} onHide={this.closePasswordModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Change Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup>
                        <ControlLabel>Current password</ControlLabel>
                        <FormControl
                            type="password"
                            placeholder="Current password"
                            value={this.state.currentPassword}
                            onChange={this.onCurrentPasswordChange}
                        />
                    </FormGroup>

                    <Password
                        label="New password"
                        placeholder="New password"
                        userInputs={[firstName, lastName, email, phoneNumber]}
                        onChange={this.onNewPasswordChange}
                    />

                    <Button
                        bsStyle="primary"
                        disabled={this.state.currentPassword.length <= 0 || !this.state.validNewPassword}
                        onClick={this.changePassword}
                    >
                        Save
                    </Button>
                    <Button onClick={this.closePasswordModal}>Cancel</Button>

                    <div className="bump-down">{alert}</div>
                </Modal.Body>
                <Modal.Footer>
                    <small>
                        Drivers can reset their own password using the Forgot password functionality in the Driver
                        Application
                    </small>
                </Modal.Footer>
            </Modal>
        )
    }

    renderPersonalInfo() {
        return (
            <Panel className="bump-down">
                <Row>
                    <Col md={8}>
                        <Row>
                            <Col md={6}>
                                <dl>
                                    <dt>First Name</dt>
                                    <dd>{this.props.user.firstName}</dd>
                                </dl>
                            </Col>
                            <Col md={6}>
                                <dl>
                                    <dt>Last Name</dt>
                                    <dd>{this.props.user.lastName}</dd>
                                </dl>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <dl>
                                    <dt>Telephone Number</dt>
                                    <dd>
                                        <a href={`tel://${this.props.user.phoneNumber}`}>
                                            {this.props.user.phoneNumber}
                                        </a>
                                        <Link to={`/admin/sms?recipient=${this.props.user.phoneNumber}`}>(SMS)</Link>
                                    </dd>
                                </dl>
                            </Col>

                            <Col md={6}>
                                <dl>
                                    <dt>Email</dt>
                                    <dd>
                                        <a href={`mailto:${this.props.user.email}`}>{this.props.user.email}</a>
                                    </dd>
                                </dl>
                            </Col>
                        </Row>
                    </Col>

                    <Col md={2} mdOffset={1}>
                        {this.props.user.userSettings.image ? (
                            <Image src={this.props.user.userSettings.image.url} circle responsive />
                        ) : null}
                    </Col>
                </Row>
            </Panel>
        )
    }

    renderSettings() {
        const roles = this.props.user.userRoles.map((r) => r.role.name).join(', ')

        return (
            <Panel>
                <Row>
                    <Col md={4}>
                        <dl>
                            <dt>Language</dt>
                            <dd>{this.props.user.userSettings.language}</dd>
                        </dl>
                    </Col>
                    <Col md={4}>
                        <dl>
                            <dt>Role(s)</dt>
                            <dd>{roles}</dd>
                        </dl>
                    </Col>
                    <Col md={4}>
                        <dl>
                            <dt>Works at Terminal</dt>
                            <dd>{this.props.user.warehouse ? this.props.user.warehouse.name : 'N/A'}</dd>
                        </dl>
                    </Col>
                </Row>
            </Panel>
        )
    }

    renderBuyers() {
        const buyers = this.props.user.connectedMerchants

        if (buyers.length === 0) {
            return (
                <div>
                    <p className="text-muted text-center">Not employed by any Merchant</p>
                </div>
            )
        }

        return (
            <div>
                {buyers.map((b) => (
                    <Link key={b.id} to={`/admin/merchants/${b.id}`}>
                        {b.name === b.externalName ? b.externalName : `${b.externalName} (${b.name})`}
                    </Link>
                ))}
            </div>
        )
    }

    renderOwnerOperators() {
        const ownerOperators = this.props.user.connectedOwnerOperators

        if (ownerOperators.length === 0) {
            return (
                <div>
                    <p className="text-muted text-center">Not employed by any Owner Operator</p>
                </div>
            )
        }
        return (
            <div>
                {ownerOperators.map((oo) => (
                    <Link key={oo.key} to={`/admin/couriers/${oo.key}`}>
                        {oo.value}
                    </Link>
                ))}
            </div>
        )
    }

    render() {
        if (undefined === this.props.user) {
            return null
        }

        return (
            <div>
                <HtmlTitle title={`${this.props.user.firstName} ${this.props.user.lastName}`} />
                <Grid fluid>
                    <Row>
                        <Col md={8} mdOffset={2}>
                            <ButtonToolbar>
                                {this.renderEditUser()}
                                {this.renderEditPassword()}
                                {this.renderDeleteUser()}
                            </ButtonToolbar>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={8} mdOffset={2}>
                            {this.renderPersonalInfo()}
                        </Col>
                    </Row>

                    <Row>
                        <Col md={8} mdOffset={2}>
                            {this.renderSettings()}
                        </Col>
                    </Row>

                    <Row>
                        <Col md={4} mdOffset={2}>
                            <Panel header="Employee of Merchant(s)">{this.renderBuyers()}</Panel>
                        </Col>

                        <Col md={4}>
                            <Panel header="Employee of Owner Operator(s)">{this.renderOwnerOperators()}</Panel>
                        </Col>
                    </Row>
                    {this.renderPasswordModal()}
                    {this.renderDeleteUserConfirmation()}
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.users.user,
    me: state.users.current,
})

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
})

View.propTypes = {
    router: PropTypes.object.isRequired,
    params: PropTypes.object,
    actions: PropTypes.object.isRequired,
    user: PropTypes.object,
    changePasswordStatus: PropTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps)(View)
